<template>
  <div
    :id="'sidebar-item-' + item.key"
    v-if="
      item.key == 'dashboard' ||
      (item.key === 'doseSpot' &&
        systemSetting?.doseSpotEnable &&
        currentUser?.doseSpotId) ||
      (item.key == 'emar' &&
        isEMAREnabled &&
        currentUser?.emarId) ||
      (item.key !== 'doseSpot' &&
        item.key !== 'emar' &&
        hasCurrentUserPermission(item.key) &&
        (item.key != 'labs' || (systemSetting && systemSetting.labEnable)))
      && !isSidebarAvailableForProviders()
    "
    class="sidebar-menu-item"
    :class="selected ? 'selected' : ''"
    :style="selected ? 'font-weight: bold' : 'filter: contrast(0.8)'"
    @click="onSidebarItemClick"
  >
    <img
      height="22"
      width="22"
      :src="require(`../../assets/icons/${item.icon}.svg`)"
      class="mr-1"
    />
    <span class="no-wrap text-white ml-3">{{ item.text }}</span>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import emarServer from '../../server/emar';

export default {
  name: "SidebarMenuItem",
  props: ["item", "selected"],
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermission"]),
    ...mapState("layout", {
      systemSetting: state => state.systemSetting,
      currentUser: state => state.currentUser,
      isEMAREnabled: state => state.systemSetting?.emarEnabled || state.systemSetting?.EMAREnabled
    })
  },
  data() {
    return {
      providersNotPermitedSiderBar:{
        emar:{
          sidebarItems:['mars'],
          isActive: () => this.isEMAREnabled
        }
      }
    }
  },
  methods: {
    ...mapMutations("layout", ["setSelectedSideBarItem"]),
    isSidebarAvailableForProviders() {
      for (const provider of Object.values(this.providersNotPermitedSiderBar)) {
        if (provider.isActive()) {
          return provider.sidebarItems.includes(this.item.key);
        }
      }
    },
    async onSidebarItemClick() {
      if (this.item.key === 'emar') {
        const url = await emarServer.getEmarLoginUrl();
        window.open(url, '_blank');
        return;
      }
      if (this.item.callback) {
        this.item.callback();
      } else {
        this.setSelectedSideBarItem(this.item.key);
      }
    }
  }
};
</script>

<style scoped>
.sidebar-menu-item {
  display: flex;
  align-items: center;
  position: relative;
  height: 50px;
  padding-left: 20px;
  margin-bottom: 3px;
  font-size: 16px;
  letter-spacing: 0.03em;
}

.sidebar-menu-item:hover {
  cursor: pointer;
  background-color: #3d42cd;
}

.sidebar-menu-item:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background-color: white;
  transition: width 200ms linear;
}

.sidebar-menu-item.selected:before {
  width: 6px;
}
</style>
